(function () {
  'use strict';

  class Helpers {
    // Parents Node
    // same like: jQuery parents();
    // eslint-disable-next-line class-methods-use-this
    parents(node) {
      let current = node;
      let list = [];
      while (current.parentNode != null && current.parentNode !== document.documentElement) {
        list.push(current.parentNode);
        current = current.parentNode;
      }
      return list;
    }

    /**
     * is Visible
     * @param el
     * @returns {boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    isVisible(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    /**
     * is Hidden
     * @param el
     * @returns {boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    isHidden(el) {
      const style = window.getComputedStyle(el);
      return style.display === 'none' || style.visibility === 'hidden';
    }

    /**
     * checkVisible
     * @param elm
     * @returns {boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    checkVisible(elm) {
      const rect = elm.getBoundingClientRect();
      const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
      return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }

    /**
     * scrollingProgress
     * @returns {number}
     */
    // eslint-disable-next-line class-methods-use-this
    scrollingProgress() {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      return winScroll / height * 100;
    }

    /**
     * getRandomChartColor
     * @param count
     * @param opposite
     * @returns {*[]}
     */
    // eslint-disable-next-line class-methods-use-this
    getRandomChartColor(count, opposite = false) {
      const flatColors = ['#1abc9c', '#e74c3c', '#f1c40f', '#3498db', '#f39c12', '#2ecc71', '#8e44ad', '#27ae60', '#e67e22', '#a29bfe', '#ff7675', '#d35400', '#2980b9', '#16a085', '#c0392b', '#9b59b6', '#34495e', '#55efc4', '#81ecec', '#74b9ff', '#00b894', '#00cec9', '#0984e3', '#6c5ce7', '#ffeaa7', '#fab1a0', '#fd79a8', '#fdcb6e', '#e17055'];
      const colors = [];
      if (opposite) {
        for (let i = 0; i < count; i++) {
          if (i === 0) {
            colors.push('#FFFFFF'); // Beyaz için ilk değer
          } else if (i === count - 1) {
            colors.push('#808080'); // Gri için son değer
          } else {
            colors.push(flatColors[i]);
          }
        }
      } else {
        for (let i = 0; i < count; i++) {
          colors.push(flatColors[i]);
        }
      }
      return colors;
    }

    /**
     * getColor
     * @param color
     * @returns {*|boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    getColor(color) {
      const colors = {
        primary: '#2bace2',
        border: '#e8e8ee',
        'neutral-100': '#f5f7f9',
        'neutral-200': '#eceff3',
        'neutral-300': '#dadee6',
        'neutral-400': '#c0c7d3',
        'neutral-500': '#959fb2',
        'neutral-600': '#636d7e',
        'neutral-700': '#394456',
        'neutral-800': '#1c2536',
        'neutral-900': '#00041a'
      };
      return colors[color] || false;
    }

    /**
     * formatNumber
     * @param num
     * @returns {string}
     */
    // eslint-disable-next-line class-methods-use-this
    formatNumber(num) {
      return num.toLocaleString();
    }

    /**
     * unFormatNumber
     * @param formattedNum
     * @returns {*}
     */
    // eslint-disable-next-line class-methods-use-this
    unformatNumber(formattedNum) {
      return formattedNum.replace(/,/g, '');
    }

    /**
     * sleep
     * @param ms
     * @returns {Promise<unknown>}
     */
    // eslint-disable-next-line class-methods-use-this
    sleep(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    }

    /**
     * Check if JS component(s) are loaded
     * @param {Element} element - DOM element to check
     * @param {string|string[]} components - Component name(s) to check
     * @returns {boolean}
     */
    // eslint-disable-next-line class-methods-use-this
    hasJSLoaded(element, components) {
      const loadedAttr = element.getAttribute('data-js-loaded');
      if (!loadedAttr) return false;
      const loadedComponents = loadedAttr.split(',').map(comp => comp.trim());
      if (Array.isArray(components)) {
        return components.every(component => loadedComponents.includes(component));
      }
      return loadedComponents.includes(components);
    }

    /**
     * Set JS component(s) as loaded
     * @param {Element} element - DOM element to mark
     * @param {string|string[]} components - Component name(s) to mark as loaded
     */
    // eslint-disable-next-line class-methods-use-this
    setJSLoaded(element, components) {
      const existingAttr = element.getAttribute('data-js-loaded');
      let loadedComponents = existingAttr ? existingAttr.split(',').map(comp => comp.trim()) : [];
      const componentsToAdd = Array.isArray(components) ? components : [components];
      componentsToAdd.forEach(component => {
        if (!loadedComponents.includes(component)) {
          loadedComponents.push(component);
        }
      });
      element.setAttribute('data-js-loaded', loadedComponents.join(','));
    }

    /**
     * Unset JS component(s) as loaded
     * @param {Element} element - DOM element to unmark
     * @param {string|string[]} components - Component name(s) to mark as not loaded
     */
    // eslint-disable-next-line class-methods-use-this
    removeJSLoaded(element, components) {
      const existingAttr = element.getAttribute('data-js-loaded');
      if (!existingAttr) return;
      const componentsToRemove = Array.isArray(components) ? components : [components];
      const loadedComponents = existingAttr.split(',').map(comp => comp.trim()).filter(comp => comp && !componentsToRemove.includes(comp));
      if (loadedComponents.length) {
        element.setAttribute('data-js-loaded', loadedComponents.join(','));
      } else {
        element.removeAttribute('data-js-loaded');
      }
    }
  }
  const {
    checkVisible,
    isVisible,
    isHidden,
    parents,
    scrollingProgress,
    getRandomChartColor,
    getColor,
    formatNumber,
    unformatNumber,
    sleep,
    hasJSLoaded,
    setJSLoaded,
    removeJSLoaded
  } = Helpers.prototype;

  // Constants for DOM selectors and class names

  // Common temporary/disposable email domains
  const DISPOSABLE_EMAIL_DOMAINS = ['tempmail.com', 'guerrillamail.com', 'mailinator.com', '10minutemail.com', 'throwaway.email', 'temp-mail.org', 'fakeinbox.com', 'maildrop.cc', 'trashmail.com', 'getairmail.com', 'yopmail.com', 'mohmal.com', 'sharklasers.com', 'getnada.com', 'emailondeck.com'];

  // Free / personal (non-corporate) email providers. Trials require a business
  // email; these are blocked client-side for instant feedback. The backend is
  // the source of truth (RestrictEmailDomain → core_restrict_email_domains) and
  // re-checks on submit, so this list only needs to catch the common providers.
  const FREE_EMAIL_DOMAINS = [
  // Google
  'gmail.com', 'googlemail.com',
  // Microsoft
  'outlook.com', 'hotmail.com', 'hotmail.co.uk', 'live.com', 'live.co.uk', 'msn.com', 'windowslive.com',
  // Yahoo
  'yahoo.com', 'yahoo.co.uk', 'yahoo.co.in', 'yahoo.fr', 'yahoo.de', 'ymail.com', 'rocketmail.com',
  // Apple
  'icloud.com', 'me.com', 'mac.com',
  // AOL
  'aol.com',
  // Proton
  'proton.me', 'protonmail.com', 'pm.me',
  // GMX / Mail.com
  'gmx.com', 'gmx.de', 'gmx.net', 'mail.com',
  // Zoho
  'zoho.com', 'zohomail.com',
  // Yandex / Russian
  'yandex.com', 'yandex.ru', 'mail.ru', 'bk.ru', 'inbox.ru', 'list.ru',
  // Other consumer webmail
  'hey.com', 'fastmail.com', 'tutanota.com', 'tuta.io', 'hushmail.com', 'web.de', 't-online.de', 'libero.it', 'orange.fr', 'free.fr', 'laposte.net', 'qq.com', '163.com', '126.com', 'naver.com', 'daum.net', 'hanmail.net'];
  const SELECTORS = {
    FORM: '#form-trial',
    SUBMIT_BUTTON: 'button[type="submit"]',
    MODAL: '.modal',
    EMAIL_INPUT: '#email',
    PREVIEW_BADGES: '[data-badge-email]',
    MODAL_RESULT: '[data-modal-result]',
    BUTTON_TYPE: '[button-type]',
    FORM_ERROR: '.form__error',
    ERROR_LABEL: '.form__error-label',
    LOGIN_BUTTON: '#loginButton',
    V2: '#recaptcha-v2'
  };
  const CLASS_NAMES = {
    PROCESSING: 'button--processing',
    HIDDEN: 'd-none',
    FLEX: 'd-flex',
    ERROR: 'is-error'
  };
  const ERROR_MESSAGES = {
    TRIAL_STARTED: 'started a trial',
    SUBSCRIBED: 'has a subscription'
  };

  // Warning icon prefixed to every form error message (both client-side
  // validation and server-side errors), so the styling stays consistent.
  const ERROR_ICON = '<svg class="form__error-icon icon"><use xlink:href="#icon-warning"></use></svg>';
  const MAIL_PROVIDERS = [{
    names: ['gmail.com', 'googlemail.com'],
    label: 'Gmail',
    url: 'https://mail.google.com/',
    mobileUrl: 'googlegmail://',
    androidIntent: 'intent://mail.google.com/mail/#Intent;scheme=https;package=com.google.android.gm;end'
  }, {
    names: ['outlook.com', 'hotmail.com', 'live.com', 'msn.com'],
    label: 'Outlook',
    url: 'https://outlook.live.com/mail/',
    mobileUrl: 'ms-outlook://',
    androidIntent: 'intent://outlook.live.com/mail/#Intent;scheme=https;package=com.microsoft.office.outlook;end'
  }, {
    names: ['office.com', 'outlook.office.com', 'microsoft.com'],
    label: 'Outlook',
    url: 'https://outlook.office.com/mail/',
    mobileUrl: 'ms-outlook://',
    androidIntent: 'intent://outlook.office.com/mail/#Intent;scheme=https;package=com.microsoft.office.outlook;end'
  }, {
    names: ['yahoo.com', 'ymail.com', 'rocketmail.com'],
    label: 'Yahoo Mail',
    url: 'https://mail.yahoo.com/',
    mobileUrl: 'ymail://',
    androidIntent: 'intent://mail.yahoo.com/#Intent;scheme=https;package=com.yahoo.mobile.client.android.mail;end'
  }, {
    names: ['icloud.com', 'me.com', 'mac.com'],
    label: 'iCloud Mail',
    url: 'https://www.icloud.com/mail/',
    mobileUrl: 'message://'
  }, {
    names: ['proton.me', 'protonmail.com'],
    label: 'Proton Mail',
    url: 'https://mail.proton.me/',
    mobileUrl: 'protonmail://'
  }, {
    names: ['zoho.com', 'zohomail.com'],
    label: 'Zoho Mail',
    url: 'https://mail.zoho.com/'
  }, {
    names: ['aol.com'],
    label: 'AOL Mail',
    url: 'https://mail.aol.com/'
  }, {
    names: ['yandex.com', 'yandex.ru'],
    label: 'Yandex Mail',
    url: 'https://mail.yandex.com/',
    mobileUrl: 'yandexmail://',
    androidIntent: 'intent://mail.yandex.com/#Intent;scheme=https;package=ru.yandex.mail;end'
  }, {
    names: ['gmx.com', 'gmx.de'],
    label: 'GMX Mail',
    url: 'https://navigator.gmx.net/mail'
  }];
  let recaptchaV2Loaded = false;
  let recaptchaV2WidgetId = null;

  // Utility functions
  const getElements = {
    form: () => document.querySelector(SELECTORS.FORM),
    submitButton: form => form?.querySelector(SELECTORS.SUBMIT_BUTTON),
    modal: form => form?.closest(SELECTORS.MODAL),
    emailInput: form => form?.querySelector(SELECTORS.EMAIL_INPUT),
    previewBadges: form => form?.querySelectorAll(SELECTORS.PREVIEW_BADGES),
    modalResults: modal => modal?.querySelectorAll(SELECTORS.MODAL_RESULT),
    buttons: form => form?.querySelectorAll(SELECTORS.BUTTON_TYPE),
    errorContainer: input => input?.parentElement.querySelector(SELECTORS.FORM_ERROR),
    errorLabel: container => container?.querySelector(SELECTORS.ERROR_LABEL),
    loginButton: form => form?.querySelector(SELECTORS.LOGIN_BUTTON),
    V3Key: form => form?.dataset.recaptchaV3Key,
    V3Threshold: form => 0.7,
    // parseFloat(form?.dataset.recaptchaThreshold) || 0.5
    V3Route: form => form?.dataset.recaptchaV3Route,
    V2Key: form => form?.dataset.recaptchaV2Key,
    V2Container: form => form?.querySelector(SELECTORS.V2)
  };

  /**
   * Toggles the submit button's processing state
   * @param {HTMLElement} button - Submit button element
   * @param {boolean} isProcessing - Processing state
   */
  const toggleButtonState = (button, isProcessing) => {
    if (!button) return;
    button.classList.toggle(CLASS_NAMES.PROCESSING, isProcessing);
    button.disabled = isProcessing;
  };

  /**
   * Toggles modal result visibility
   * @param {HTMLElement} modal - Modal element
   * @param {string|null} type - Result type to show
   * @param {string|null} emailValue - Email value for dynamic button update
   */
  const toggleModalResult = (modal, type, emailValue = null) => {
    if (type === 'success' && emailValue) {
      updateMailButton(emailValue);
      initResendButton(emailValue);
    }
    getElements.modalResults(modal)?.forEach(el => {
      el.classList.add(CLASS_NAMES.HIDDEN);
      el.classList.remove(CLASS_NAMES.FLEX);
    });
    if (type) {
      const modalElement = modal?.querySelector(`[data-modal-result="${type}"]`);
      if (modalElement) {
        modalElement.classList.remove(CLASS_NAMES.HIDDEN);
        modalElement.classList.add(CLASS_NAMES.FLEX);
      }
    }
  };

  /**
   * Toggles trial/login buttons visibility
   * @param {HTMLElement} form - Form element
   * @param {boolean} showLogin - Whether to show login buttons
   */
  const toggleTrialButtons = (form, showLogin = false) => {
    getElements.buttons(form)?.forEach(el => {
      const isTrial = el.getAttribute('button-type') === 'start-free-trial';
      el.classList.toggle(CLASS_NAMES.HIDDEN, showLogin ? isTrial : !isTrial);
      el.classList.toggle(CLASS_NAMES.FLEX, showLogin ? !isTrial : isTrial);
    });
  };

  /**
   * Validate email for suspicious patterns (fake/spam emails)
   * @param {string} email
   * @returns {{isValid: boolean, message: string}}
   */
  const validateEmailQuality = email => {
    if (!email || typeof email !== 'string') {
      return {
        isValid: false,
        message: 'Please enter a valid email address.'
      };
    }
    const emailLower = email.toLowerCase().trim();

    // Basic email format validation
    const basicEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!basicEmailRegex.test(emailLower)) {
      return {
        isValid: false,
        message: 'Please enter a valid email address.'
      };
    }
    const [localPart, domain] = emailLower.split('@');

    // Check 1: Too many dots in local part (before @)
    const dotsInLocal = (localPart.match(/\./g) || []).length;
    if (dotsInLocal >= 4) {
      return {
        isValid: false,
        message: 'This email address appears to be invalid. Please use a valid email.'
      };
    }

    // Check 2: Contains plus sign (often used for disposable emails)
    const hasPlus = localPart.includes('+');
    if (hasPlus) {
      return {
        isValid: false,
        message: 'Email addresses with + character are not allowed. Please use a different email.'
      };
    }

    // Check 3: Check for repeating characters in domain (e.g., asdasd.com, aaabbb.com)
    // Extract domain name without TLD
    const domainParts = domain.split('.');
    const domainName = domainParts[0]; // Get the main domain name

    // Check for same character repeating more than 3 times consecutively
    const consecutiveRepeats = /(.)\1{3,}/.test(domainName);
    if (consecutiveRepeats) {
      return {
        isValid: false,
        message: 'This email domain appears to be invalid. Please use a valid email.'
      };
    }

    // Check for patterns like "asdasd" or "abcabc" (repeated sequences)
    const hasRepeatedSequence = str => {
      // Check for 2-4 character sequences that repeat
      for (let len = 2; len <= 4; len += 1) {
        for (let i = 0; i <= str.length - len * 2; i += 1) {
          const sequence = str.substring(i, i + len);
          const nextSequence = str.substring(i + len, i + len * 2);
          if (sequence === nextSequence) {
            // Check if this pattern repeats more than twice
            const regex = new RegExp(`(${sequence}){3,}`);
            if (regex.test(str)) {
              return true;
            }
          }
        }
      }
      return false;
    };
    if (hasRepeatedSequence(domainName)) {
      return {
        isValid: false,
        message: 'This email domain appears to be invalid. Please use a valid email.'
      };
    }

    // Check 4: Disposable/temporary email services
    if (DISPOSABLE_EMAIL_DOMAINS.includes(domain) || DISPOSABLE_EMAIL_DOMAINS.some(d => domain.endsWith(d))) {
      return {
        isValid: false,
        message: 'Temporary email addresses are not allowed. Please use a permanent email.'
      };
    }

    // Check 5: Free / personal (non-corporate) email providers.
    // Message mirrors the backend (TrialController → RestrictEmailDomain) so the
    // user sees the same text whichever layer rejects the address.
    if (FREE_EMAIL_DOMAINS.includes(domain)) {
      return {
        isValid: false,
        message: "MagicPort doesn't accept personal email addresses. Please use your company email."
      };
    }

    // Check 6: Too many numbers in local part (common in spam)
    const numbersInLocal = (localPart.match(/\d/g) || []).length;
    const localLength = localPart.length;
    const numberRatio = numbersInLocal / localLength;

    // If more than 60% of local part is numbers
    if (numberRatio > 0.6) {
      return {
        isValid: false,
        message: 'This email address appears to be suspicious. Please use a valid email.'
      };
    }

    // Check 7: Random character patterns (e.g., xb.gxtmpq.w.gz.t.zc.f.av@gmail.com)
    if (dotsInLocal >= 3 && localLength > 15) {
      // Check if average segment length is very short (indicates random pattern)
      const segments = localPart.split('.');
      const avgSegmentLength = segments.reduce((sum, seg) => sum + seg.length, 0) / segments.length;
      if (avgSegmentLength < 3) {
        return {
          isValid: false,
          message: 'This email address appears to be invalid. Please use a valid email.'
        };
      }
    }

    // All checks passed
    return {
      isValid: true,
      message: ''
    };
  };

  /**
   * Show form error for a specific input
   * @param {HTMLElement} input - Input element
   * @param {string} message - Error message
   */
  const showFormError = (input, message) => {
    if (!input) return;
    const errorContainer = getElements.errorContainer(input);
    const errorLabel = getElements.errorLabel(errorContainer);
    if (errorContainer) {
      if (errorLabel) {
        errorLabel.innerHTML = `${ERROR_ICON} ${message}`;
      }
      errorContainer.classList.remove(CLASS_NAMES.HIDDEN);
    }
    input.classList.add(CLASS_NAMES.ERROR);
  };

  /**
   * Hide form error for a specific input
   * @param {HTMLElement} input - Input element
   */
  const hideFormError = input => {
    if (!input) return;
    const errorContainer = getElements.errorContainer(input);
    if (errorContainer) {
      errorContainer.classList.add(CLASS_NAMES.HIDDEN);
    }
    input.classList.remove(CLASS_NAMES.ERROR);
  };

  /**
   * Displays form errors
   * @param {HTMLElement} form - Form element
   * @param {Object} errors - Error messages object
   */
  const showErrors = (form, errors) => {
    Object.entries(errors).forEach(([fieldName, messages]) => {
      const input = form.querySelector(`[name="${fieldName}"]`);
      if (!input) return;
      const errorContainer = getElements.errorContainer(input);
      if (!errorContainer) return;
      const errorLabel = getElements.errorLabel(errorContainer);
      if (!errorLabel) return;
      errorContainer.classList.remove(CLASS_NAMES.HIDDEN);
      const errorMessages = Array.isArray(messages) ? messages.join(', ') : messages;
      errorLabel.innerHTML = `${ERROR_ICON} ${errorMessages}`;
      input.classList.add(CLASS_NAMES.ERROR);
      if (errorMessages.includes(ERROR_MESSAGES.TRIAL_STARTED) || errorMessages.includes(ERROR_MESSAGES.SUBSCRIBED)) {
        toggleTrialButtons(form, true);
      }
    });
  };

  /**
   * Clears form errors
   * @param {HTMLElement} form - Form element
   */
  const clearErrors = form => {
    form.querySelectorAll(SELECTORS.FORM_ERROR).forEach(container => {
      container.classList.add(CLASS_NAMES.HIDDEN);
      const label = getElements.errorLabel(container);
      if (label) label.textContent = '';
    });
    form.querySelectorAll(`.${CLASS_NAMES.ERROR}`).forEach(input => input.classList.remove(CLASS_NAMES.ERROR));
  };

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  /**
   * Check if device is iOS
   * @returns {boolean}
   */
  const isIOS = () => {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  };

  /**
   * Check if device is Android
   * @returns {boolean}
   */
  const isAndroid = () => {
    return /Android/i.test(navigator.userAgent);
  };

  /**
   * getMailProvider
   * @param {string} email
   * @returns {{label: string, url: string, mobileUrl?: string, androidIntent?: string} | null}
   */
  const getMailProvider = email => {
    const domain = email.split('@')[1]?.toLowerCase();
    if (!domain) return null;

    // eslint-disable-next-line no-restricted-syntax
    for (const provider of MAIL_PROVIDERS) {
      if (provider.names.includes(domain)) {
        return provider;
      }
    }
    return null;
  };
  const updateMailButton = email => {
    const modal = getElements.modal(getElements.form());
    const mailButton = modal?.querySelector('[data-button-dynamic-provider]');
    const mailButtonTitle = modal?.querySelector('[data-button-dynamic-provider-title]');
    if (!mailButton) return;
    const provider = getMailProvider(email);
    if (provider) {
      // Known provider
      let targetUrl = provider.url;

      // Use mobile deep links if on mobile
      if (isMobileDevice()) {
        if (isAndroid() && provider.androidIntent) {
          targetUrl = provider.androidIntent;
        } else if (isIOS() && provider.mobileUrl) {
          targetUrl = provider.mobileUrl;
        }
      }
      mailButton.href = targetUrl;
      if (mailButtonTitle) {
        mailButtonTitle.textContent = provider.label;
      }
    } else {
      // Unknown provider - use mailto to open default mail app
      mailButton.href = `mailto:${email}`;
      if (mailButtonTitle) {
        mailButtonTitle.textContent = 'Mail App';
      }
    }
  };

  /**
   * Handles form submission
   * @param {Event} e - Submit event
   * @param {Object} elements - Form elements
   */
  const handleSubmit = async (e, elements) => {
    e.preventDefault();
    const {
      form,
      submitButton,
      modal,
      modalInstance,
      emailInput,
      previewBadges,
      recaptchaV2Loaded
    } = elements;

    // Validate email quality before submitting
    const emailValue = emailInput.value.trim();
    const validation = validateEmailQuality(emailValue);
    if (!validation.isValid) {
      showFormError(emailInput, validation.message);
      return;
    }
    toggleButtonState(submitButton, true);
    previewBadges?.forEach(badge => {
      badge.textContent = emailInput.value.trim();
    });
    const formData = new FormData(form);
    let recaptchaResponse = null;
    if (recaptchaV2Loaded) {
      recaptchaResponse = grecaptcha.getResponse(recaptchaV2WidgetId);
      if (!recaptchaResponse) {
        console.error('reCAPTCHA v2 response is missing.');
        toggleButtonState(submitButton, false);
        let errorEl = getElements.V2Container(form).querySelector('.form__error');
        if (!errorEl) {
          errorEl = document.createElement('div');
          errorEl.className = 'form__error';
          errorEl.innerHTML = '<span class="form__error-label">Please verify reCAPTCHA.</span>';
          getElements.V2Container(form).appendChild(errorEl);
        } else {
          const label = errorEl.querySelector('.form__error-label');
          if (label) label.textContent = 'Please verify reCAPTCHA.';
        }
        return;
      }
      formData.append('g-recaptcha-response', recaptchaResponse);
    }
    try {
      const response = await fetch(form.getAttribute('action'), {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        }
      });
      toggleModalResult(modal, null);
      if (!response.ok) {
        const statusCode = response.status;
        let errorData = await response.json();
        let errors = errorData.errors || errorData;
        if (statusCode === 400 && (errors.key === 'user_already_signed_in' || errors.key === 'user_already_signed_and_has_trial_redirect_to_mi')) {
          window.location.href = errors.url;
          return;
        }
        if (statusCode === 400 && (errors.key === 'user_already_registered' || errors.key === 'user_already_registered_and_has_trial_redirect_to_login')) {
          getElements.loginButton(form)?.setAttribute('href', errors.url);
          errors = {
            email: ['You already have an account. Please log in.']
          };
          toggleTrialButtons(form, true);
        }
        if (statusCode === 400 && errors.key === 'user_already_registered_and_has_trial_redirect_to_mi') {
          getElements.loginButton(form)?.setAttribute('href', errors.url);
          errors = {
            email: ['You already have an account. Please log in.']
          };
          toggleTrialButtons(form, true);
        }
        showErrors(form, errors);
        return;
      }
      const data = await response.json();
      switch (data.flow) {
        case 1:
          toggleModalResult(modal, 'success', emailInput.value.trim());
          break;
        case 2:
          toggleModalResult(modal, 'pending');
          break;
        case 3:
          toggleModalResult(modal, 'ending');
          break;
      }
      if (modalInstance) modalInstance.setStep(2);
      clearErrors(form);
      form.reset();
    } catch (error) {
      if (modalInstance) modalInstance.setStep(1);
    } finally {
      resetV2Captcha();
      toggleButtonState(submitButton, false);
    }
  };

  /**
   * Format time remaining
   * @param {number} seconds
   * @returns {string}
   */
  const formatTimeRemaining = seconds => {
    if (seconds <= 0) return '0s';
    if (seconds < 60) {
      return `${seconds}s`;
    }
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    if (remainingSeconds === 0) {
      return `${minutes}m`;
    }
    return `${minutes}m ${remainingSeconds}s`;
  };
  const initResendButton = emailValue => {
    const modal = getElements.modal(getElements.form());
    const resendButton = modal?.querySelector('[data-resend-link]');
    if (!resendButton) return;

    // Check if already initialized
    if (resendButton.dataset.initialized === 'true') return;
    resendButton.dataset.initialized = 'true';
    const initialCooldown = parseInt(resendButton.dataset.resendLink, 10) || 60;
    let cooldownRemaining = 0;
    let cooldownInterval = null;

    // Find the message element and remaining time span
    const messageElement = modal?.querySelector('[data-resend-text]');
    const remainingElement = messageElement?.querySelector('[data-resend-remaining]');

    /**
     * Update button state and message
     */
    const updateButtonState = () => {
      if (cooldownRemaining > 0) {
        resendButton.disabled = true;

        // Update remaining time display
        if (remainingElement) {
          remainingElement.textContent = formatTimeRemaining(cooldownRemaining);
        }

        // eslint-disable-next-line no-plusplus
        cooldownRemaining--;
      } else {
        // Cooldown finished
        if (cooldownInterval) {
          clearInterval(cooldownInterval);
          cooldownInterval = null;
        }
        resendButton.disabled = false;

        // Hide the message
        if (messageElement) {
          messageElement.classList.add('d-none');
        }
      }
    };

    /**
     * Start cooldown timer
     */
    const startCooldown = () => {
      cooldownRemaining = initialCooldown;

      // Show the message
      if (messageElement) {
        messageElement.classList.remove('d-none');
      }
      updateButtonState();
      if (cooldownInterval) {
        clearInterval(cooldownInterval);
      }
      cooldownInterval = setInterval(updateButtonState, 1000);
    };

    /**
     * Handle resend click
     */
    const handleResend = async (e, emailValue) => {
      e.preventDefault();
      e.stopPropagation();
      if (resendButton.disabled) return;

      // Add processing state
      resendButton.classList.add('button--processing');
      resendButton.disabled = true;

      // Simulate ajax request
      await sleep(2000);

      // Remove processing state but keep disabled
      resendButton.classList.remove('button--processing');

      // Start cooldown timer
      startCooldown();
      const formData = new FormData();
      formData.append('email', emailValue);
      formData.append('fromResend', 'on');
      await fetch(getElements.form().getAttribute('action'), {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        }
      });
    };

    // resendButton.removeEventListener('click', handleResend);
    resendButton.addEventListener('click', function (e) {
      handleResend(e, emailValue);
    });
  };
  const initV2Captcha = form => {
    if (!getElements.V2Key(form) || recaptchaV2Loaded) return;
    grecaptcha.ready(function () {
      recaptchaV2WidgetId = grecaptcha.render(getElements.V2Container(form), {
        sitekey: getElements.V2Key(form),
        callback: function (token) {
          recaptchaV2Loaded = true;
        },
        'error-callback': function () {
          console.error('reCAPTCHA v2 error occurred.');
        },
        'expired-callback': function () {
          console.warn('reCAPTCHA v2 expired. Please complete it again.');
        }
      });
    });
  };
  const resetV2Captcha = () => {
    if (recaptchaV2Loaded) {
      grecaptcha.reset(recaptchaV2WidgetId);
    }
  };
  const logToServer = (reCAPTCHAV3VerificationFailedOrLowScore, data, trim) => {
    fetch('/log-recaptcha-issue', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      },
      body: JSON.stringify({
        message: reCAPTCHAV3VerificationFailedOrLowScore,
        details: data,
        email: trim
      })
    }).catch(err => {
      console.log('Error logging to server:', err);
    });
  };
  /**
   * Initializes trial form functionality
   */
  const initTrial = () => {
    const form = getElements.form();
    if (!form) return;
    const elements = {
      form,
      submitButton: getElements.submitButton(form),
      modal: getElements.modal(form),
      modalInstance: form.closest(SELECTORS.MODAL)?._modal,
      emailInput: getElements.emailInput(form),
      previewBadges: getElements.previewBadges(form),
      recaptchaV2Loaded: recaptchaV2Loaded
    };

    /**
     * Handle email input validation
     */
    // `force` = true runs full validation even on an incomplete value (used on
    // blur), so non-email / malformed input is caught by our own message instead
    // of the browser's native HTML5 bubble.
    // Shows/hides the inline error for early feedback. The submit button is NOT
    // disabled — the real gate is in the submit handler below, so the user can
    // always click and immediately see why submission is blocked.
    // `force` = true validates even an incomplete value (used on blur), so
    // non-email / malformed input is caught by our own message.
    const handleEmailValidation = (force = false) => {
      const emailValue = elements.emailInput?.value?.toString()?.trim() || '';

      // Empty: just clear any error.
      if (emailValue.length === 0) {
        hideFormError(elements.emailInput);
        return;
      }
      const looksComplete = emailValue.includes('@') && emailValue.split('@')[1]?.includes('.');

      // Still typing (not forced) and not yet complete: don't nag mid-typing.
      if (!looksComplete && !force) {
        return;
      }

      // Forced (blur) or complete-looking: full validation. Invalid — including
      // "not an email at all" — shows our error; valid hides it.
      const validation = validateEmailQuality(emailValue);
      if (!validation.isValid) {
        showFormError(elements.emailInput, validation.message);
      } else {
        hideFormError(elements.emailInput);
      }
    };

    // Add real-time validation event listeners
    if (elements.emailInput) {
      // Blur forces full validation so malformed/non-email input surfaces an error.
      elements.emailInput.addEventListener('blur', () => handleEmailValidation(true));
      elements.emailInput.addEventListener('input', () => {
        // Only hide error on input, don't show new errors while typing
        const emailValue = elements.emailInput?.value?.toString()?.trim() || '';
        if (emailValue.length > 0) {
          // Debounce validation while typing
          clearTimeout(elements.emailInput.validationTimeout);
          elements.emailInput.validationTimeout = setTimeout(handleEmailValidation, 500);
        } else {
          // Cleared the field → clear the error too.
          handleEmailValidation();
        }
      });
    }
    form.addEventListener('submit', function (e) {
      // Front-end gate: if the email fails validation, show the error and send
      // NO request at all (not even the reCAPTCHA verification call).
      const emailValue = elements.emailInput?.value?.toString()?.trim() || '';
      const validation = validateEmailQuality(emailValue);
      if (!validation.isValid) {
        showFormError(elements.emailInput, validation.message);
        return;
      }
      grecaptcha.execute(getElements.V3Key(form), {
        action: 'submit'
      }).then(function (token) {
        fetch(getElements.V3Route(form), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          },
          body: JSON.stringify({
            token: token
          })
        }).then(res => res.json()).then(data => {
          if (data.success && data.score >= getElements.V3Threshold(form) || recaptchaV2Loaded) {
            elements.recaptchaV2Loaded = recaptchaV2Loaded;
            handleSubmit(e, elements);
          } else {
            initV2Captcha(form);
            logToServer('reCAPTCHA v3 verification failed or low score.', data, elements.emailInput.value.trim());
          }
        }).catch(err => {
          console.log(err);
        });
      });
    });
  };

  // Initialize on DOM content loaded
  document.addEventListener('DOMContentLoaded', initTrial);

})();
